export { default as isEduFaculty } from './isEduFaculty';
export { default as isEduStudent } from './isEduStudent';
export { default as isEdu } from './isEdu';
